<template>
  <div style="background-color: red" v-if="member">
    <!-- <v-row no-gutters justify="center">
    <v-col cols="11">
      <v-text-field
      class="mt-4"
      dense
      append-icon="mdi-filter"
      @click:append="dialog = true"
      clear-icon="mdi-close-circle"
      clearable
      @click:clear="clearMessage"
      v-model="searchText"
        outlined
        label="Search"
        prepend-inner-icon="mdi-magnify"
      ></v-text-field>
    </v-col>
  </v-row> -->
    <div
      class="pa-1 mb-0"
      style="background-color: #fff; font-size: 20px;text-shadow: 3px 3px 2px #D8D2CB;"
    >
       <v-icon right>mdi-magnify</v-icon>
       เลือกเพื่อค้นหาประเภทกิจกรรม
    </div>
    <v-row no-gutters justify="center">
    <v-col cols="11">
      <v-text-field
      class="mt-4"
      dense
      append-icon="mdi-filter"
      @click:append="dialog = true"
      clear-icon="mdi-close-circle"
      clearable
      readonly
      @click:clear="clearMessage"
      v-model="searchText"
        outlined
        label="Search"
        prepend-inner-icon="mdi-magnify"
      @click="dialog = true"
      ></v-text-field>
    </v-col>
  </v-row>
    <!-- <v-row style="background-color: #fff;" align="center" justify="space-around" class="pl-6 pr-6">
      <v-btn
        style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
        class="mb-2 mt-2"
        outlined
        small
        @click="search('OneTime'), (dialog = false)"
        color="red"
      >
        ครั้งเดียว
        <v-icon right> mdi-numeric-1-box </v-icon>
      </v-btn>
      <v-btn
        style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
        class="mb-2 mt-2"
        outlined
        small
        @click="search('Daily'), (dialog = false)"
        color="green"
      >
        รายวัน
        <v-icon right> mdi-alpha-d-box </v-icon>
      </v-btn>
      <v-btn
        style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
        class="mb-2 mt-2"
        outlined
        small
        @click="search('Weekly'), (dialog = false)"
        color="primary"
      >
        รายวันสัปดาห์
        <v-icon right> mdi-alpha-w-box </v-icon>
      </v-btn>
      <v-btn
        style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
        class="mb-6"
        outlined
        small
        @click="search('Monthly'), (dialog = false)"
        color="deep-purple"
      >
        รายเดือน
        <v-icon right> mdi-alpha-m-box </v-icon>
      </v-btn>
      <v-btn
        style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
        class="mb-6"
        outlined
        small
        color="indigo"
        @click="search('All'), (dialog = false)"
      >
        ทั้งหมด
        <v-icon right> mdi-alpha-a-box </v-icon>
      </v-btn>
    </v-row> -->
    <div>
      <div
        class="pa-1 pl-4 mb-5"
        :style="'background-color: ' + ($isTargetShop ? '#FFA300' : $bgColor) + '; font-size: 20px; color: #fff;opacity: 0.6;'"
      >
        กิจกรรมครั้งเดียว
      </div>
      <v-card
      v-for="(item, i) in itemSearch.filter(
        (a) =>
          new Date(a.startDate).getTime() <= this.today.getTime() &&
          this.today.getTime() < new Date(a.endDate).getTime()
      ).filter(b => b.repeats === 'OneTime')"
      :key="i"
      class="ml-4 mr-4 mb-0 mt-8"
    >
      <v-row>
        <v-col class="col-5 pt-0 pb-0 mb-0">
          <v-img
            :src="item.pictureUrl"
            style="width: 100%; height: auto"
            height="100"
            class="picUrl"
          >
            <v-chip
              class="ma-2 ml-n1 mt-n1 coin_icon_small"
              color="#FF4B42"
              label
              text-color="white"
            >
              {{ item.coin }}
            </v-chip>
          </v-img>
        </v-col>
        <v-col class="col-7">
          <v-row class="font11 headline1">
            <v-col style="text-shadow: 3px 3px 2px #D8D2CB;" class="pl-0 pt-2 pb-3">{{ item.title }}</v-col>
          </v-row>
         <v-row class="headline1 mb-3">
            <!-- <v-col class="pl-0 pt-0 pb-3"> -->
              <v-btn small tile :color="item.repeatColor " dark>{{
                item.repeats
              }}</v-btn>
            <!-- </v-col> -->
            <!-- <v-col class="pl-0 pt-0 pb-3 ml-n16"> -->
              <v-btn small :color="item.typeColor" dark>{{
                item.type
              }}</v-btn>
            <!-- </v-col> -->
          </v-row>
          <v-row style="text-shadow: 3px 3px 2px #D8D2CB;">ใช้ได้ถึง {{item.endDate}}</v-row>
          <v-row class="font14 icon2">
            <v-col class="pt-1 text-end pr-6">
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse < item.quota"
                color="green darken-4"
                >รับแล้ว</v-chip
              >
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse >= item.quota"
                color="green darken-4"
                >มีคนเข้าร่วมกิจกรรมครบแล้ว</v-chip
              >
              <v-btn
                v-if="!item.statusChk && item.countUse < item.quota"
                style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
                outlined
                rounded
                small
                color="#FF4B42"
                @click="submit(item)"
                >เก็บคะแนน</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-card-actions class="mx-0 px-0 pt-3 pb-0">
        <v-progress-linear
          :v-model="(item.countUse * 100) / item.quota"
          height="25"
        >
          <v-icon right :color="'#7CCC63'"> mdi-account </v-icon>
          <strong>{{ item.countUse }} / {{ item.quota }} </strong>
        </v-progress-linear>
      </v-card-actions>
    </v-card>
    </div>
    <div>
      <div
        class="pa-2 pl-4 mb-5 mt-3"
        :style="'background-color: ' + ($isTargetShop ? '#FFA300' : $bgColor) + '; font-size: 20px; color: #fff;opacity: 0.6;'"
      >
        กิจกรรมประจำวัน
      </div>
      <v-card
      v-for="(item, i) in itemSearch.filter(
        (a) =>
          new Date(a.startDate).getTime() <= this.today.getTime() &&
          this.today.getTime() < new Date(a.endDate).getTime()
      ).filter(b => b.repeats === 'Daily')"
      :key="i"
      class="ml-4 mr-4 mb-0 mt-8"
    >
      <v-row>
        <v-col class="col-5 pt-0 pb-0 mb-0">
          <v-img
            :src="item.pictureUrl"
            style="width: 100%; height: auto"
            height="100"
            class="picUrl"
          >
            <v-chip
              class="ma-2 ml-n1 mt-n1 coin_icon_small"
              color="#FF4B42"
              label
              text-color="white"
            >
              {{ item.coin }}
            </v-chip>
          </v-img>
        </v-col>
        <v-col class="col-7">
          <v-row class="font11 headline1">
            <v-col class="pl-0 pt-2 pb-3">{{ item.title }}</v-col>
          </v-row>
          <v-row class="headline1 mb-3">
              <v-btn small tile :color="item.repeatColor" dark>{{
                item.repeats
              }}</v-btn>
              <v-btn small :color="item.typeColor" dark>{{
                item.type
              }}</v-btn>
          </v-row>
                    <v-row style="text-shadow: 3px 3px 2px #D8D2CB;">ใช้ได้ถึง {{item.endDate}}</v-row>
          <v-row class="font14 icon2">
            <v-col class="pt-1 text-end pr-6">
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse < item.quota"
                color="green darken-4"
                >รับแล้ว</v-chip
              >
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse >= item.quota"
                color="green darken-4"
                >มีคนเข้าร่วมกิจกรรมครบแล้ว</v-chip
              >
              <v-btn
                v-if="!item.statusChk && item.countUse < item.quota"
                style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
                outlined
                rounded
                small
                color="#FF4B42"
                @click="submit(item)"
                >เก็บคะแนน</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-card-actions class="mx-0 px-0 pt-3 pb-0">
        <v-progress-linear
          :v-model="(item.countUse * 100) / item.quota"
          height="25"
        >
          <v-icon right :color="'#7CCC63'"> mdi-account </v-icon>
          <strong>{{ item.countUse }} / {{ item.quota }} </strong>
        </v-progress-linear>
      </v-card-actions>
    </v-card>
    </div>
    <div>
      <div
        class="pa-2 pl-4 mb-5 mt-3"
        :style="'background-color: ' + ($isTargetShop ? '#FFA300' : $bgColor) + '; font-size: 20px; color: #fff;opacity: 0.6;'"
      >
        กิจกรรมประจำสัปดาห์
      </div>
      <v-card
      v-for="(item, i) in itemSearch.filter(
        (a) =>
          new Date(a.startDate).getTime() <= this.today.getTime() &&
          this.today.getTime() < new Date(a.endDate).getTime()
      ).filter(b => b.repeats === 'Weekly')"
      :key="i"
      class="ml-4 mr-4 mb-0 mt-8"
    >
      <v-row>
        <v-col class="col-5 pt-0 pb-0 mb-0">
          <v-img
            :src="item.pictureUrl"
            style="width: 100%; height: auto"
            height="100"
            class="picUrl"
          >
            <v-chip
              class="ma-2 ml-n1 mt-n1 coin_icon_small"
              color="#FF4B42"
              label
              text-color="white"
            >
              {{ item.coin }}
            </v-chip>
          </v-img>
        </v-col>
        <v-col class="col-7">
          <v-row class="font11 headline1">
            <v-col class="pl-0 pt-2 pb-3">{{ item.title }}</v-col>
          </v-row>
          <v-row class="headline1 mb-3">
              <v-btn small tile :color="item.repeatColor" dark>{{
                item.repeats
              }}</v-btn>
              <v-btn small :color="item.typeColor" dark>{{
                item.type
              }}</v-btn>
          </v-row>
                    <v-row style="text-shadow: 3px 3px 2px #D8D2CB;">{{item.endDate}}</v-row>
          <v-row class="font14 icon2">
            <v-col class="pt-1 text-end pr-6">
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse < item.quota"
                color="green darken-4"
                >รับแล้ว</v-chip
              >
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse >= item.quota"
                color="green darken-4"
                >มีคนเข้าร่วมกิจกรรมครบแล้ว</v-chip
              >
              <v-btn
                v-if="!item.statusChk && item.countUse < item.quota"
                style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
                outlined
                rounded
                small
                color="#FF4B42"
                @click="submit(item)"
                >เก็บคะแนน</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-card-actions class="mx-0 px-0 pt-3 pb-0">
        <v-progress-linear
          :v-model="(item.countUse * 100) / item.quota"
          height="25"
        >
        <v-icon right :color="'#7CCC63'"> mdi-account </v-icon>
          <strong>{{ item.countUse }} / {{ item.quota }} </strong>
        </v-progress-linear>
      </v-card-actions>
    </v-card>
    </div>
    <div>
      <div
        class="pa-2 pl-4 mb-5 mt-3"
        :style="'background-color: ' + ($isTargetShop ? '#FFA300' : $bgColor) + '; font-size: 20px; color: #fff;opacity: 0.6;'"
      >
        กิจกรรมประจำเดือน
      </div>
      <v-card
      v-for="(item, i) in itemSearch.filter(
        (a) =>
          new Date(a.startDate).getTime() <= this.today.getTime() &&
          this.today.getTime() < new Date(a.endDate).getTime()
      ).filter(b => b.repeats === 'Monthly')"
      :key="i"
      class="ml-4 mr-4 mb-0 mt-8"
    >
      <v-row>
        <v-col class="col-5 pt-0 pb-0 mb-0">
          <v-img
            :src="item.pictureUrl"
            style="width: 100%; height: auto"
            class="picUrl"
          >
            <v-chip
              class="ma-2 ml-n1 mt-n1 coin_icon_small"
              color="#FF4B42"
              label
              text-color="white"
            >
              {{ item.coin }}
            </v-chip>
          </v-img>
        </v-col>
        <v-col class="col-7">
          <v-row class="font11 headline1">
            <v-col class="pl-0 pt-2 pb-3">{{ item.title }}</v-col>
          </v-row>
          <v-row class="headline1 mb-3">
              <v-btn small tile :color="item.repeatColor" dark>{{
                item.repeats
              }}</v-btn>
              <v-btn small :color="item.typeColor" dark>{{
                item.type
              }}</v-btn>
          </v-row>
                    <v-row style="text-shadow: 3px 3px 2px #D8D2CB;">ใช้ได้ถึง {{item.endDate}}</v-row>
          <v-row class="font14 icon2">
            <v-col class="pt-1 text-end pr-6">
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse < item.quota"
                color="green darken-4"
                >รับแล้ว</v-chip
              >
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse >= item.quota"
                color="green darken-4"
                >มีคนเข้าร่วมกิจกรรมครบแล้ว</v-chip
              >
              <v-btn
                v-if="!item.statusChk && item.countUse < item.quota"
                style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
                outlined
                rounded
                small
                color="#FF4B42"
                @click="submit(item)"
                >เก็บคะแนน</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-card-actions class="mx-0 px-0 pt-3 pb-0">
        <v-progress-linear
          :v-model="(item.countUse * 100) / item.quota"
          height="25"
        >
          <v-icon right :color="'#7CCC63'"> mdi-account </v-icon>
          <strong>{{ item.countUse }} / {{ item.quota }} </strong>
        </v-progress-linear>
      </v-card-actions>
    </v-card>
    </div>
    <!-- <v-row class="ml-1 mr-1">
      <v-col class="text-center">
        <v-col style="padding: 0;">
          <v-btn
            class="ma-2 short"
            outlined
            small
            @click="search('OneTime'), (dialog = false)"
            color="red"
          >
            One Time
            <v-icon right> mdi-numeric-1-box </v-icon>
          </v-btn>
        </v-col>
        <v-col style="padding: 0;">
          <v-btn
            class="ma-2 short"
            outlined
            small
            @click="search('Daily'), (dialog = false)"
            color="green"
          >
            Daily
            <v-icon right> mdi-alpha-d-box </v-icon>
          </v-btn>
        </v-col>
        <v-col style="padding: 0;">
          <v-btn
            class="ma-2 short"
            outlined
            small
            @click="search('Weekly'), (dialog = false)"
            color="primary"
          >
            Weekly
            <v-icon right> mdi-alpha-w-box </v-icon>
          </v-btn>
        </v-col>
        <v-col style="padding: 0;">
          <v-btn
            class="ma-2 short"
            outlined
            small
            @click="search('Monthly'), (dialog = false)"
            color="deep-purple"
          >
            Monthly
            <v-icon right> mdi-alpha-m-box </v-icon>
          </v-btn>
        </v-col>
        <v-col style="padding: 0;">
          <v-btn
            class="ma-2 short"
            outlined
            small
            color="indigo"
            @click="search('All'), (dialog = false)"
          >
            ทั้งหมด
            <v-icon right> mdi-alpha-a-box </v-icon>
          </v-btn>
        </v-col>
      </v-col>
    </v-row> -->
    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            กรุณาเลือก
          </v-card-title>

          <v-card-text>
            <layout>
              <v-row class="ml-1 mr-1">
                <v-col class="text-center">
                  <v-btn
                    class="ma-2 short"
                    outlined
                    small
                    @click="search('OneTime'), (dialog = false)"
                    color="red"
                  >
                    One Time
                    <v-icon right> mdi-numeric-1-box </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2 short"
                    outlined
                    small
                    @click="search('Daily'), (dialog = false)"
                    color="green"
                  >
                    Daily
                    <v-icon right> mdi-alpha-d-box </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2 short"
                    outlined
                    small
                    @click="search('Weekly'), (dialog = false)"
                    color="primary"
                  >
                    Weekly
                    <v-icon right> mdi-alpha-w-box </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2 short"
                    outlined
                    small
                    @click="search('Monthly'), (dialog = false)"
                    color="deep-purple"
                  >
                    Monthly
                    <v-icon right> mdi-alpha-m-box </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2 short"
                    outlined
                    small
                    color="indigo"
                    @click="search('All'), (dialog = false)"
                  >
                    ทั้งหมด
                    <v-icon right> mdi-alpha-a-box </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center">
      <v-dialog v-model="dialogDoc" persistent>
        <v-card>
          <!-- <v-card-title class="text-h5 grey lighten-2">
          กรอกข้อมูล
        </v-card-title> -->
          <v-form ref="form_add" v-model="valid" lazy-validation>
            <v-card-text>
              <v-container class="pl-4 pr-4 pt-5">
                <v-row justify="center">
                  <v-col cols="3">
                    <v-img
                      :src="require('@/assets/activityAdd.svg')"
                      height="48px"
                      width="42px"
                    ></v-img>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col class="text-center">
                    <b class="font24">กรอกข้อมูล</b>
                  </v-col>
                </v-row>
                <v-row style="height: 70px" v-if="formUpdate.field1Title">
                  <v-col cols="12">
                    <v-text-field
                      :label="formUpdate.field1Title"
                      v-if="formUpdate.field1Type !== 'dateTime'"
                      outlined
                      dense
                      :rules="
                        formUpdate.field1Type === 'citizenNumber'
                          ? [formUpdate.key1.email]
                          : formUpdate.field1Type === 'email'
                          ? [formUpdate.key1.email]
                          : [formUpdate.key1.required]
                      "
                      required
                      v-model="formUpdateItem.field1Value"
                    ></v-text-field>
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formUpdateItem.field1Value"
                          :label="formUpdate.field1Title"
                          readonly
                          v-if="formUpdate.field1Type == 'dateTime'"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker1"
                        v-model="formUpdateItem.field1Value"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save1"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row style="height: 70px" v-if="formUpdate.field2Title">
                  <v-col cols="12">
                    <v-text-field
                      :label="formUpdate.field2Title"
                      v-if="formUpdate.field2Type !== 'dateTime'"
                      outlined
                      dense
                      :rules="
                        formUpdate.field2Type === 'citizenNumber'
                          ? [formUpdate.key2.email]
                          : formUpdate.field2Type === 'email'
                          ? [formUpdate.key2.email]
                          : [formUpdate.key2.required]
                      "
                      required
                      v-model="formUpdateItem.field2Value"
                    ></v-text-field>
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formUpdateItem.field2Value"
                          :label="formUpdate.field2Title"
                          readonly
                          v-if="formUpdate.field2Type == 'dateTime'"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker2"
                        v-model="formUpdateItem.field2Value"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save2"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row style="height: 70px" v-if="formUpdate.field3Title">
                  <v-col cols="12">
                    <v-text-field
                      :label="formUpdate.field3Title"
                      v-if="formUpdate.field3Type !== 'dateTime'"
                      outlined
                      dense
                      :rules="[formUpdate.key3.required]"
                      required
                      v-model="formUpdateItem.field3Value"
                    ></v-text-field>
                    <v-menu
                      ref="menu3"
                      v-model="menu3"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formUpdateItem.field3Value"
                          :label="formUpdate.field3Title"
                          readonly
                          v-if="formUpdate.field3Type == 'dateTime'"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker3"
                        v-model="formUpdateItem.field3Value"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save3"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row style="height: 70px" v-if="formUpdate.field4Title">
                  <v-col cols="12">
                    <v-text-field
                      :label="formUpdate.field4Title"
                      v-if="formUpdate.field4Type !== 'dateTime'"
                      outlined
                      dense
                      :rules="[formUpdate.key4.required]"
                      required
                      v-model="formUpdateItem.field4Value"
                    ></v-text-field>
                    <v-menu
                      ref="menu4"
                      v-model="menu4"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formUpdateItem.field4Value"
                          :label="formUpdate.field4Title"
                          prepend-icon="event"
                          readonly
                          v-if="formUpdate.field4Type == 'dateTime'"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker4"
                        v-model="formUpdateItem.field4Value"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save4"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <div class="text-center">
                  <v-btn
                    rounded
                    color="#C62929"
                    dark
                    width="100px"
                    :disabled="!valid"
                    @click="successAlert = true"
                  >
                    Get
                  </v-btn>
                  <v-btn
                    rounded
                    color="#808588"
                    dark
                    width="100px"
                    @click="dialogDoc = false"
                  >
                    Cancel
                  </v-btn>
                </div>
              </v-container>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="success" persistent>
      <v-card class="pa-7">
        <v-row>
          <v-col class="text-center"
            ><span class="coin_icon_large"></span
          ></v-col>
        </v-row>
        <v-row>
          <v-col class="text-center pb-0"
            ><span class="headline1 font28 weight1000"
              >คุณได้รับคะแนนเพิ่ม</span
            ></v-col
          >
        </v-row>
        <v-row v-if="point">
          <v-col class="text-center pa-0"
            ><span class="headline1 font55 weight1000">{{ point }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pt-0"
            ><span class="headline1 font28 weight1000">คะแนน</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center">
            <v-btn rounded class="btn_icon1" dark @click="$router.push('home')">
              ดูคะแนนสะสม และ ของรางวัล
            </v-btn>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="successAlert" persistent>
      <v-card class="pa-7">
        <v-row justify="center" align="center">
          <v-col cols="3">
            <v-img
              :src="require('@/assets/activityV.svg')"
              height="48px"
              width="36px"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <b class="font24">ยืนยันรับของรางวัล</b>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col cols="10">
            <v-img
              :src="require('@/assets/activityChk.svg')"
              height="210px"
              width="224.36px"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <b class="font13">รับCoinsฟรี!!!</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <b class="coin_icon_small font20">{{ coinChk }} </b>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-btn
            rounded
            color="#C62929"
            dark
            width="100px"
            @click="useActivity()"
          >
            Get
          </v-btn>
          <v-btn
            rounded
            color="#808588"
            dark
            width="100px"
            @click="successAlert = false"
          >
            Cancel
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-bottom-sheet
      v-if="levelUpdate"
      v-model="levelup"
      persistent
      hide-on-scroll
      overlay-opacity="1"
    >
      <v-sheet class="text-center" height="75vh">
        <v-img
          src="/static/img/papershoot.png"
          style="position: absolute; top: 0"
        />
        <v-img
          src="/static/img/golden.png"
          max-width="300"
          max-height="392"
          style="position: absolute; top: 60px; left: 35px"
        />
        <v-row style="padding-top: 240px">
          <v-col class="text-center pb-0"
            ><span class="headline1 font55 bold">Congrats!</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pb-0"
            ><span class="headline2 font18 bold"
              >คุณได้รับคะแนนเพิ่ม</span
            ></v-col
          >
        </v-row>
        <v-row v-if="point">
          <v-col class="text-center pa-0"
            ><span class="headline2 font24 weight1000">{{ point }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pt-0"
            ><span class="headline2 font18 bold">คะแนน</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pt-0 pb-0"
            ><span class="headline1 font24 bold"
              >และได้อัพเกรดเป็นสมาชิก</span
            ></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pt-0 pb-3"
            ><span class="headline1 font28 weight1000">{{
              levelUpdate.name
            }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="ml-5 mr-5 text-center">
            <v-btn
              rounded
              class="btn_icon1"
              dark
              @click="$router.push('privilege')"
            >
              ดูสิทธิประโยชน์ที่ได้รับเพื่มเติม
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<style scoped>
.short {
  width: 200px;
}
.short span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.picUrl {
  border-radius: 10px 10px 10px 10px;
}
</style>
<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment' // แปลง date
export default {
  name: 'AllActivity',
  data () {
    return {
      // activePicker: null,
      repeatCaption: {
        OneTime: 'รับได้ครั้งเดียว',
        Daily: 'รับได้วันละครั้ง',
        Weekly: 'รับได้สัปดาห์ละครั้ง',
        Monthly: 'รับได้เดือนละครั้ง'
      },
      today: new Date(),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dialog: false,
      dialogDoc: false,
      successAlert: false,
      valid: true,
      success: true,
      levelup: false,
      levelUpdate: null,
      point: null,
      level: null,
      member: null,
      searchText: '',
      items: [],
      itemSearch: [],
      shopId: null,
      coinChk: '',
      // itemCheck: [],
      tab: 0,
      formUpdate: {
        activityId: '',
        field1Title: '',
        field1Type: '',
        key1: {},
        chkKey: '',
        field2Title: '',
        field2Type: '',
        key2: {},
        field3Title: '',
        field3Type: '',
        key3: {},
        field4Title: '',
        field4Type: '',
        key4: {},
        primary: '',
        coin: '',
        pictureUrl: '',
        title: ''
      },
      formUpdateItem: {
        field1Value: '',
        field2Value: '',
        field3Value: '',
        field4Value: ''
      }
    }
  },
  watch: {
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker1.activePicker = 'YEAR'))
    },
    menu2 (val) {
      val && setTimeout(() => (this.$refs.picker2.activePicker = 'YEAR'))
    },
    menu3 (val) {
      val && setTimeout(() => (this.$refs.picker3.activePicker = 'YEAR'))
    },
    menu4 (val) {
      val && setTimeout(() => (this.$refs.picker4.activePicker = 'YEAR'))
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    await this.getActivity()
    await this.getLevelDB()
    if (this.$route.query.activityId) {
      this.addData()
    }
    // await this.getChkActivity()
  },
  async updated () {
    this.level = this.getLevel()
    // await this.getChkActivity()
  },
  methods: {
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getLevelDB () {
      const result = await this.callBeTaskAPI(
        'get',
        '/level/line/get?RECORD_STATUS=N'
      )
      if (result) {
        if (result.length > 0) {
          // this.setLevel(result)
          this.level = result
          return result
        }
      }
    },
    clearMessage () {
      this.searchText = ''
    },
    save1 (date) {
      this.$refs.menu1.save(date)
    },
    save2 (date) {
      this.$refs.menu2.save(date)
    },
    save3 (date) {
      this.$refs.menu3.save(date)
    },
    save4 (date) {
      this.$refs.menu4.save(date)
    },
    validate () {
      this.$nextTick(() => {
        let self = this
        self.$refs.form_add.validate()
      })
    },
    search (repeats) {
      this.searchText = repeats
      if (repeats === 'All') {
        this.itemSearch = this.items
      } else {
        var dataCheck = this.items.filter(function (el) {
          return el.repeats === repeats
        })
        this.itemSearch = dataCheck
      }
    },
    async getActivity () {
      const result = await this.callBeTaskAPIActivity(
        'get',
        '/activity/line/get'
      )
      if (result) {
        let rs = result.filter(a => a.type !== 'video')
        for (var i = 0; i < rs.length; i++) {
          var d = rs[i]
          var url = ''
          if (d.repeats === 'OneTime') {
            url =
              '/activityLog/line/get?activityId=' +
              d.activityId +
              '&shopId=' +
              d.shopId +
              '&lineUserId=' +
              this.profile.userId
            d.repeatColor = '#FC9590'
          }
          if (d.repeats === 'Daily') {
            url =
              '/activityLog/line/get?activityId=' +
              d.activityId +
              '&shopId=' +
              d.shopId +
              '&lineUserId=' +
              this.profile.userId +
              '&joinDate=' +
              moment(new Date()).format('YYYY-MM-DD')
            d.repeatColor = '#B3E48E'
          }
          if (d.repeats === 'Weekly') {
            url =
              '/activityLog/line/get?activityId=' +
              d.activityId +
              '&shopId=' +
              d.shopId +
              '&lineUserId=' +
              this.profile.userId +
              '&joinWeek=' +
              moment(new Date(), 'YYYYMMDD').isoWeek() +
              '&joinYear=' +
              moment(new Date()).format('YYYY')
            d.repeatColor = '#327BC7'
          }
          if (d.repeats === 'Monthly') {
            url =
              '/activityLog/line/get?activityId=' +
              d.activityId +
              '&shopId=' +
              d.shopId +
              '&lineUserId=' +
              this.profile.userId +
              '&joinMonth=' +
              moment(new Date()).format('MM') +
              '&joinYear=' +
              moment(new Date()).format('YYYY')
            d.repeatColor = '#6445AB'
          }
          if (d.type === 'กรอกข้อมูล') {
            d.typeColor = '#F56867'
          }
          if (d.type === 'FreeCoin') {
            d.typeColor = '#7CCC63'
          }
          if (d.type === 'LuckyDraw') {
            d.typeColor = '#F39C12'
          }
          const resultChk = await this.callBeTaskAPIActivity('get', url)
          if (resultChk.status === false) {
            d.statusChk = false
          } else {
            d.statusChk = true
          }
          this.items.push(d)
          this.itemSearch.push(d)
        }
        // this.items = result
        // this.itemSearch = result
      }
    },
    submit (item) {
      if (item.type === 'กรอกข้อมูล') {
        this.formUpdate.activityId = item.activityId
        this.formUpdate.field1Title = item.field1Title
        this.formUpdate.field1Type = item.field1Type
        this.formUpdate.field2Title = item.field2Title
        this.formUpdate.field2Type = item.field2Type
        this.formUpdate.field3Title = item.field3Title
        this.formUpdate.field3Type = item.field3Type
        this.formUpdate.field4Title = item.field4Title
        this.formUpdate.field4Type = item.field4Type
        this.formUpdate.primary = item.Primary_field
        this.formUpdate.pictureUrl = item.pictureUrl
        this.formUpdate.title = item.title
        this.formUpdate.coin = item.coin
        // this.formUpdateItem.field1Value = ''
        // this.formUpdateItem.field2Value = ''
        // this.formUpdateItem.field3Value = ''
        // this.formUpdateItem.field4Value = ''
        switch (item.Primary_field) {
          case '1':
            this.formUpdate.key1 = {
              numberRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
              counterTel: (value) => value.length <= 10 || 'Max 10 characters',
              IDcardRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
              required: (value) => !!value || 'กรุณากรอก.',
              resizeImag: (value) =>
                !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
              counterIDcard: (value) =>
                value.length <= 13 || 'Max 13 characters',
              email: (value) => {
                const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
              }
            }
            this.formUpdate.key2 = {
              required: (value) => value.length <= 5000
            }
            this.formUpdate.key3 = {
              required: (value) => value.length <= 5000
            }
            this.formUpdate.key4 = {
              required: (value) => value.length <= 5000
            }
            // this.formUpdate.chkKey = '/activityData/get?field1Value=' + this.formUpdateItem.field1Value + '&activityId=' + this.formUpdate.activityId
            break
          case '2':
            this.formUpdate.key2 = {
              numberRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
              counterTel: (value) => value.length <= 10 || 'Max 10 characters',
              IDcardRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
              required: (value) => !!value || 'กรุณากรอก.',
              resizeImag: (value) =>
                !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
              counterIDcard: (value) =>
                value.length <= 13 || 'Max 13 characters',
              email: (value) => {
                const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
              }
            }
            this.formUpdate.key1 = {
              required: (value) => value.length <= 5000
            }
            this.formUpdate.key3 = {
              required: (value) => value.length <= 5000
            }
            this.formUpdate.key4 = {
              required: (value) => value.length <= 5000
            }
            // this.formUpdate.chkKey = '/activityData/get?field2Value=' + this.formUpdateItem.field2Value + '&activityId=' + this.formUpdate.activityId
            break
          case '3':
            this.formUpdate.key3 = {
              numberRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
              counterTel: (value) => value.length <= 10 || 'Max 10 characters',
              IDcardRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
              required: (value) => !!value || 'กรุณากรอก.',
              resizeImag: (value) =>
                !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
              counterIDcard: (value) =>
                value.length <= 13 || 'Max 13 characters',
              email: (value) => {
                const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
              }
            }
            this.formUpdate.key1 = {
              required: (value) => value.length <= 5000
            }
            this.formUpdate.key2 = {
              required: (value) => value.length <= 5000
            }
            this.formUpdate.key4 = {
              required: (value) => value.length <= 5000
            }
            // this.formUpdate.chkKey = '/activityData/get?field3Value=' + this.formUpdateItem.field3Value + '&activityId=' + this.formUpdate.activityId
            break
          case '4':
            this.formUpdate.key4 = {
              numberRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
              counterTel: (value) => value.length <= 10 || 'Max 10 characters',
              IDcardRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
              required: (value) => !!value || 'กรุณากรอก.',
              resizeImag: (value) =>
                !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
              counterIDcard: (value) =>
                value.length <= 13 || 'Max 13 characters',
              email: (value) => {
                const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
              }
            }
            this.formUpdate.key1 = {
              required: (value) => value.length <= 5000
            }
            this.formUpdate.key2 = {
              required: (value) => value.length <= 5000
            }
            this.formUpdate.key3 = {
              required: (value) => value.length <= 5000
            }
            // this.formUpdate.chkKey = '/activityData/get?field4Value=' + this.formUpdateItem.field4Value + '&activityId=' + this.formUpdate.activityId
            break
          case '':
            this.formUpdate.key1 = {
              numberRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
              counterTel: (value) => value.length <= 10 || 'Max 10 characters',
              IDcardRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
              required: (value) => !!value || 'กรุณากรอก.',
              resizeImag: (value) =>
                !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
              counterIDcard: (value) =>
                value.length <= 13 || 'Max 13 characters',
              email: (value) => {
                const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
              }
            }
            this.formUpdate.key2 = {
              numberRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
              counterTel: (value) => value.length <= 10 || 'Max 10 characters',
              IDcardRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
              required: (value) => !!value || 'กรุณากรอก.',
              resizeImag: (value) =>
                !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
              counterIDcard: (value) =>
                value.length <= 13 || 'Max 13 characters',
              email: (value) => {
                const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
              }
            }
            this.formUpdate.key3 = {
              numberRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
              counterTel: (value) => value.length <= 10 || 'Max 10 characters',
              IDcardRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
              required: (value) => !!value || 'กรุณากรอก.',
              resizeImag: (value) =>
                !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
              counterIDcard: (value) =>
                value.length <= 13 || 'Max 13 characters',
              email: (value) => {
                const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
              }
            }
            this.formUpdate.key4 = {
              numberRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
              counterTel: (value) => value.length <= 10 || 'Max 10 characters',
              IDcardRules: (value) =>
                (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
              required: (value) => !!value || 'กรุณากรอก.',
              resizeImag: (value) =>
                !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
              counterIDcard: (value) =>
                value.length <= 13 || 'Max 13 characters',
              email: (value) => {
                const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
              }
            }
            // this.formUpdate.chkKey = '/activityData/get?field1Value=' + this.formUpdateItem.field1Value + '&activityId=' + this.formUpdate.activityId
            break
          default:
            break
        }
        this.validate()
        this.coinChk = item.coin
        this.dialogDoc = true
        // this.useActivity(this.formUpdate)
      } else {
        this.formUpdateItem.field1Value = ''
        this.formUpdateItem.field2Value = ''
        this.formUpdateItem.field3Value = ''
        this.formUpdateItem.field4Value = ''
        this.formUpdate.activityId = item.activityId
        this.successAlert = true
        this.coinChk = item.coin
        // this.useActivity(item)
      }
    },
    async useActivity (activity) {
      if (this.formUpdate.primary === '1') {
        this.formUpdate.chkKey =
          '/activityData/get?field1Value=' +
          this.formUpdateItem.field1Value +
          '&activityId=' +
          this.formUpdate.activityId
        await this.chkPrimary()
      } else if (this.formUpdate.primary === '2') {
        this.formUpdate.chkKey =
          '/activityData/get?field1Value=' +
          this.formUpdateItem.field2Value +
          '&activityId=' +
          this.formUpdate.activityId
        await this.chkPrimary()
      } else if (this.formUpdate.primary === '3') {
        this.formUpdate.chkKey =
          '/activityData/get?field1Value=' +
          this.formUpdateItem.field3Value +
          '&activityId=' +
          this.formUpdate.activityId
        await this.chkPrimary()
      } else if (this.formUpdate.primary === '4') {
        this.formUpdate.chkKey =
          '/activityData/get?field1Value=' +
          this.formUpdateItem.field4Value +
          '&activityId=' +
          this.formUpdate.activityId
        await this.chkPrimary()
      } else {
        await this.addData()
      }
      //   }
      // })
    },
    async callBeTaskAPIActivity (method, url, params) {
      let result = null
      await axios({
        method: method,
        headers: {
          shopId: this.shopId,
          lineUserId: this.profile.userId,
          activityId: this.$route.query.activityId ? this.$route.query.activityId : this.formUpdate.activityId
        },
        url: this.DNS_IP + url,
        data: params
      })
        .then((response) => {
          result = response.data
        })
        .catch((error) => {
          console.error(error)
          result = null
        })
      return result
    },
    async chkPrimary () {
      const results = await this.callBeTaskAPI('get', this.formUpdate.chkKey)
      if (results.status === false) {
        await this.addData()
      } else {
        Swal.fire({
          title: `มีข้อมูลอยู่แล้ว`,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ตกลง'
        }).then((confirm) => {
          if (confirm.isConfirmed) {
            location.reload()
          }
        })
      }
    },
    async addData () {
      const params = {
        field1Value: this.formUpdateItem.field1Value,
        field2Value: this.formUpdateItem.field2Value,
        field3Value: this.formUpdateItem.field3Value,
        field4Value: this.formUpdateItem.field4Value
      }
      const result = await this.callBeTaskAPIActivity(
        'post',
        `/activityLog/add`,
        params
      )
      if (result.status) {
        this.point = result.coin
        this.success = true
        await this.getMemberProfile()
        this.member = this.GET_MEMBERINFO()
      } else {
        var titles = ''
        if (result.message === 'lineUserId is already') {
          titles = `คุณเคยได้รับรางวัลนี้แล้ว`
        }
        if (result.message === 'expired') {
          titles = `รางวัลนี้ หมดอายุแล้ว`
        }
        Swal.fire({
          title: titles,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ตกลง'
        }).then((confirm) => {
          if (confirm.isConfirmed) {
            this.$router.push('/activity')
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Activity/AllActivity.vue